import * as React from "react";
import { useState, useEffect, useRef } from "react";
import apiCall from "../../helpers/apifactory";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Player, ControlBar } from "video-react";
import "./../../../node_modules/video-react/dist/video-react.css";
import { Link } from "react-router-dom";
import ErrorText from "./ErrorText";
import * as Yup from "yup";
import { useFormik } from "formik";
import styles from "../../Styles/modal.module.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "800px", // Set your width here
    },
  },
}));
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const FooterComponent = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 50);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 200;

      top > header_height && window_width > 1024
        ? document
            .querySelector("nav")
            .classNameList?.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classNameList?.remove("fixed-header-desktop");
    },
    false
  );

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [show, setShow] = useState(false);
  const modalRef = useRef(null);
  useEffect(() => {
    if (show) {
      modalRef.current.classList?.add(styles.visible);
    } else {
      modalRef.current.classList?.remove(styles.visible);
    }
  }, [show]);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
    }),
    onSubmit: (values) => {
      const body = {
        toEmailID: "tcs.updates@tcs.com.pk",
        emailSubject: values?.email,
        emailText: values?.email,
        cc: values?.email,
        bcc: values?.email,
        attachments: [],
        replyTo: values?.custEmail,
      };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          //console.log('Response:', res);
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });
  return (
    <>
      <footer id="main-footer" className="border-t mt-[-1rem ]">
        <div className="main-footer max-w-[70rem] mx-auto lg:flex md:grid lg:flex-col-4 md:flex-col-2 md:flex-row lg:py-[7rem] py-[40px] px-8 lg:gap-0 md:gap-1 flex-wrap">
          <div className="footer-part sm:flex grid flex-1">
            <div className="flex-1 flex">
              <ul className="flex-1 text-sm flex flex-col gap-1 link">
                <li className="font-bold mb-4 text-lg link-title">
                  Company Information
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>

                <li>
                  <Link to="/about/mission">Mission & Core Values</Link>
                </li>
                <li>
                  <Link to="/leadership">Leadership</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
              </ul>
            </div>
            <div className="flex-1 sm:flex grid footer-services sm:mt-[0rem] mt-[1rem]">
              <ul className="flex-1 text-sm flex flex-col gap-1 link ">
                <li className="font-bold mb-4 text-lg link-title">
                  Product & Services
                </li>
                <li>
                  <Link to="/tcsexpress">Express</Link>
                </li>
                <li>
                  <Link to="/tcslogistics">Logistics</Link>
                </li>
                <li>
                  <Link to="/brands">Brands</Link>
                </li>
                <li>
                  <a
                    className="cursor-pointer hover:z-50 md:w-[27.5%] lg:w-[208px]"
                    onClick={() => {
                      handleClickOpen();
                    }}
                  >
                    Promotions
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="grid sm:flex flex-1 gap-0 footer-part sm:mt-[0rem] mt-[1rem]">
            <div className="flex-1 flex w-[14rem] lg:mt-0 md:mt-10 sm:mt-3">
              <ul className="flex-1 text-sm flex flex-col gap-1 link">
                <li className="font-bold sm:mb-4 mb-2 text-lg link-title">
                  Head Office
                </li>
                <p className="w-[70%]">
                  101-104
                  <br />
                  Civil Aviation Club Road
                  <br />
                  Karachi 75202, Pakistan
                </p>
              </ul>
            </div>
            <div className="flex-1 lg:mt-0 md:mt-10 footer-services sm:mt-3 mt-[1rem]">
              <h2 className="font-bold mb-4 text-lg">Signup for Updates</h2>
              <form className="flex  items-center rounded-sm">
                <input
                  type="email"
                  className="no-border px-2 py-1 xl:w-[19rem] lg:w-[17rem] md:w-[15rem] h-[2.2rem] rounded-l-sm"
                  required
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                <button
                  onClick={formik?.handleSubmit}
                  type="submit"
                  className="rounded-r-sm bg-[#ed1c24] p-2 w-[4rem] h-[2.2rem] flex justify-center items-center"
                >
                  <img src="/signup.png" alt="" className="w-[1.8rem] " />
                </button>
              </form>
              <ErrorText
                text={formik?.touched?.email && formik?.errors?.email}
              />
              <h2 className="font-bold mb-4 text-lg sm:mt-8 mt-4">Follow Us</h2>
              <div className="flex gap-4">
                <a target="_blank" href="https://www.facebook.com/tcscouriers/">
                  <img src="/social/fb.svg" alt="" className="h-5 social_f" />
                </a>
                <a
                  target="_blank"
                  href="https://web.whatsapp.com/+9221111123456"
                >
                  <img
                    src="/social/whatsapp.svg"
                    alt=""
                    className="h-5 social_w"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/tcs_couriers/"
                >
                  <img
                    src="/social/instagram.svg"
                    alt=""
                    className="h-5 social_i"
                  />
                </a>
                <a target="_blank" href="https://twitter.com/tcs_couriers">
                  <img
                    src="/social/twitter.svg"
                    alt=""
                    className="h-5 social_t"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.youtube.com/channel/UCrniUiy5dGDEZ1f4jieAS3Q"
                >
                  <img
                    src="/social/youtube.svg"
                    alt=""
                    className="h-5 social_y"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/tcs-private-limited/?originalSubdomain=pk"
                >
                  <img
                    src="/social/linkedin.svg"
                    alt=""
                    className="h-5 social_l"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className=" bg-[#f1f1f1]">
          <div className="max-w-[70rem] mx-auto flex justify-between items-center p-6 text-sm text-[#606060] flex-col md:flex-row">
            <div>2025 © TCS Private Ltd. All rights reserved.</div>
            <ul className="flex gap-3 md:gap-6  text-xs md:text-sm link">
              <a href="/terms-of-use">
                <li>Terms of Use</li>
              </a>
              <a href="/privacy-policy">
                <li>Privacy Policy</li>
              </a>

              <li>
                <Link to="/customer-services/laptop-faqs">FAQs</Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          ref={modalRef}
          className={`${styles.modal__wrap}`}
          onClick={() => setShow(false)}
        >
          <div
            className={`flex flex-col justify-center items-center ${styles.modal}`}
          >
            <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
              <div className="flex justify-center items-center">
                <img
                  src="/popup-circle.png"
                  alt=""
                  className="mx-auto w-[12.5rem]"
                />
                <img
                  src="/popup-icon.png"
                  alt=""
                  className="absolute top-[-3.5rem] mx-auto w-[7rem]"
                />
              </div>
              <div className="absolute right-[1rem] top-[1rem] ">
                <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
              </div>
              <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
                <h2 className="font-bold text-xl">Thank you for submitting.</h2>
                <p>We’ll contact you soon.</p>
              </div>
            </div>
            <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
          </div>
        </div>
      </footer>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="video-modal"
        open={open}
      >
        <DialogContent dividers>
          <Player autoPlay={true}>
            <source src="./video/promotion_video.mp4" />
            <ControlBar autoHide={false} />
          </Player>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default FooterComponent;
